module.exports = __webpack_public_path__ + "static/media/inventory.8a731373.svg";